import { render } from "./HelloWorld.vue?vue&type=template&id=23798428&lang=pug&bindings={\"capturedEmail\":\"data\",\"classes\":\"options\",\"submitEmail\":\"options\",\"yesEmail\":\"options\",\"msg\":\"props\"}"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script